<template>
  <div>
    <v-layout align-center justify-space-between class="mb-4">
      <h2 class="title grey--text text--darken-2">My Listings</h2>
      <v-btn
        depressed
        color="secondary"
        class="white--text"
        :to="{ name: 'Provider-New-Listing' }"
      >
        <v-icon left>add</v-icon> New Listing
      </v-btn>
    </v-layout>

    <div v-if="loading" class="text-xs-center pa-4">
      <v-progress-circular indeterminate color="secondary" />
    </div>

    <v-alert v-else-if="!listings.length" type="info" outline>
      You haven't submitted any listings yet. Click "New Listing" to get
      started.
    </v-alert>

    <v-card v-for="listing in listings" :key="listing.id" class="mb-3 pa-3">
      <v-layout wrap align-start>
        <v-flex grow>
          <div class="subheading font-weight-medium">{{ listing.title }}</div>
          <div class="body-2 grey--text mt-1">
            {{ listing.description | truncate }}
          </div>

          <div
            v-if="listing.status === 'denied' && listing.denial_reason"
            class="mt-2"
          >
            <v-chip small color="red lighten-4" text-color="red darken-2"
              >Denied</v-chip
            >
            <div class="body-2 red--text mt-1">
              <strong>Reason:</strong> {{ listing.denial_reason }}
            </div>
          </div>
          <div v-else class="mt-2">
            <v-chip
              small
              :color="statusColor(listing.status)"
              :text-color="statusTextColor(listing.status)"
            >
              {{ statusLabel(listing.status) }}
            </v-chip>
          </div>
        </v-flex>

        <v-flex shrink class="ml-3">
          <v-btn
            small
            flat
            :disabled="
              listing.status === 'pending_new' ||
                listing.status === 'pending_edit'
            "
            :title="
              listing.status === 'pending_edit'
                ? 'An edit is already pending review'
                : ''
            "
            :to="{ name: 'Provider-Edit-Listing', params: { id: listing.id } }"
          >
            Edit
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
      {{ snackbar.message }}
      <v-btn flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ProviderListings",
  filters: {
    truncate(value) {
      if (!value) return "";
      return value.length > 120 ? value.slice(0, 120) + "…" : value;
    }
  },
  data() {
    return {
      listings: [],
      loading: false,
      snackbar: { show: false, message: "", color: "success" }
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.listings = await this.$store.dispatch("fetchProviderListings");
      } catch {
        this.snackbar = {
          show: true,
          message: "Could not load listings.",
          color: "error"
        };
      } finally {
        this.loading = false;
      }
    },
    statusLabel(status) {
      return (
        {
          approved: "Approved",
          pending_new: "Pending Review",
          pending_edit: "Edit Pending Review",
          denied: "Denied"
        }[status] || status
      );
    },
    statusColor(status) {
      return (
        {
          approved: "green lighten-4",
          pending_new: "orange lighten-4",
          pending_edit: "orange lighten-4",
          denied: "red lighten-4"
        }[status] || "grey lighten-3"
      );
    },
    statusTextColor(status) {
      return (
        {
          approved: "green darken-2",
          pending_new: "orange darken-2",
          pending_edit: "orange darken-2",
          denied: "red darken-2"
        }[status] || "grey darken-2"
      );
    }
  }
};
</script>
